import { GoogleMap, useLoadScript, MarkerF} from "@react-google-maps/api"
import {  useMemo } from "react"
import Loading from "../Loading/Loading"
import "../../../styles/MapaIframe.css"

interface ChildProps {
  longitud: string,
  latitud: string
}
const Mapa: React.FC<ChildProps> = ({latitud, longitud}) =>{
  const apiKey =  process.env.REACT_APP_GOOGLE_MAPS_APIKEY
  const zoom = 18
  const {isLoaded} = useLoadScript(
    {googleMapsApiKey: `${apiKey}`
    
  })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const MapCenter = useMemo(() => ({lat: Number(latitud), lng: Number(longitud)}),[])
    return(
      !isLoaded?
      <Loading/>
      :
      <div className= "contenedorMapa-iframe">
        <Map/>
      </div>
      )
function Map (){
  return (
    <GoogleMap 
    zoom={zoom} 
    center={MapCenter} 
    mapContainerClassName="contentMapaStyle"
    >
      <MarkerF position={MapCenter} />
    </GoogleMap>
    )
}      

}
export default Mapa